import React, { useEffect, useState } from 'react';
import { Routes, useLocation } from 'react-router-dom';
import { generateRouteComponents } from 'utils/routing-helper';
import { routes } from 'components/App/routes';
import PropTypes from 'prop-types';
import { filter, isNil } from 'lodash';
import DefaultLayout from '../Components/Layouts/DefaultLayout';

function App({ isNotFound })
{
    const [routeChanges, setRouteChanges] = useState(0);
    const location = useLocation();
    /*
     * the route change always init as 1 for ssr routes, so we use only notFoundPage if isNotFound (initial prop from 404 page)
     * and route changes are not detected. After the first user interaction all routes are available
     */
    const activeRoutes = isNotFound && routeChanges < 2 ? filter(routes, { name: 'notFoundPage' }) : routes;

    useEffect(() =>
    {
        const params = new URLSearchParams(location.search);
        const formTemplate = params.get('form');

        if (!isNil(formTemplate))
        {
            localStorage.setItem('formTemplate', formTemplate);
        }

        setRouteChanges(prevState => prevState + 1);
    }, [location]);

    return (
        <div>
            <DefaultLayout>
                <Routes>
                    {generateRouteComponents(activeRoutes)}
                </Routes>
            </DefaultLayout>
        </div>
    );
}

App.defaultProps = {
    isNotFound: false,
};

App.propTypes = {
    isNotFound: PropTypes.bool,
};

export default App;
